<template>
    <div id="home">
           <!-- Navigation -->
  <nav class="navbar navbar-light bg-light static-top">
    <div class="container">
      <a class="navbar-brand" href="#"><img src="../images/ams-icon.png" width="140" /></a>
    </div>
  </nav>

  <!-- Masthead-->
  <header class="masthead text-white text-center">
    <div class="overlay"/>
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <h1 class="mb-5"></h1>
            </div>
        </div>
        <div class="col-lg-4">
            <h3 class="mb-5"></h3>
        </div>
    </div>
  </header>

  <!-- Icons Grid -->
  <section class="features-icons bg-light text-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
            <div class="features-icons-icon d-flex">
              <i class="fa fa-map-marked m-auto text-primary"></i>
            </div>
            <h3>Map</h3>
            <p class="lead mb-0">Explore the visions of the area</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
            <div class="features-icons-icon d-flex">
              <i class="fa fa-search m-auto text-primary"></i>
            </div>
            <h3>Learn</h3>
            <p class="lead mb-0">Check out previous successful projects</p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="features-icons-item mx-auto mb-0 mb-lg-3">
            <div class="features-icons-icon d-flex">
              <i class="fa fa-users m-auto text-primary"></i>
            </div>
            <h3>Voice your opinion</h3>
            <p class="lead mb-0">Have your say in a structured way!</p>
          </div>
        </div>
      </div>
    </div>
  </section>

    </div>
</template>
<script>
export default{
data() {
    return {
        id:0
    }
},
}
</script>


// WEBPACK FOOTER //
// src/pages/home.vue